/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Plain_Text_Import_Docx_Error_ToastInputs */



/**
* | output |
* | --- |
* | "Error processing DocX: {error}" |
*
* @param {Plain_Text_Import_Docx_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_docx_error_toast = /** @type {((inputs: Plain_Text_Import_Docx_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Docx_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors du traitement du DocX : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler bei der Verarbeitung von DocX: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante l'elaborazione di DocX: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка обработки DocX: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al procesar DocX: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`处理 DocX 时出错：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`DocX の処理中にエラーが発生しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`DocX को संसाधित करने में त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao processar o DocX: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error processing DocX: ${i?.error}`)
});